import { Grid, Typography } from "@mui/material";

interface UnderConstructionProps {
  text?: string;
}

export function UnderConstruction(props: UnderConstructionProps) {
  const { text } = props;

  return (
    <Grid
      container
      justifyContent="center"
      spacing={3}
      alignItems="flex-start"
      sx={{mt: '10em'}}
    >
      <Grid item lg={12}>
        <Typography textAlign={"center"} variant="h2">
          Under construction
        </Typography>
      </Grid>
      <Grid item lg={12} xl={12} xs={12} sm={12} md={12} textAlign="center">
        <img
          src={"/underconstruction-01.svg"}
          alt="underCons"
          style={{ width: 100 }}
        />
      </Grid>
    </Grid>
  );
}
